import { idFlavor } from "@specsheet-common/shared-types";
import { queryKeys } from "src/service/queryHooks/keys";
import { queryClient } from "src/service/reactQuery";

export type CampaignAuthContext = {
  userId: string;
  organisationId: string;
  workspaceId: string;
};

type CampaignPermissionCacheGuard = {
  onAuthContext(next: CampaignAuthContext): void;
  reset(): void;
};

/**
 * Drops permission-bearing campaign caches when user/org/workspace changes.
 * Active queries refetch; idle keys are not force-fetched.
 */
export const createCampaignPermissionCacheGuard =
  (): CampaignPermissionCacheGuard => {
    let previous: CampaignAuthContext | null = null;

    return {
      onAuthContext(next: CampaignAuthContext): void {
        const contextChanged =
          !previous ||
          previous.userId !== next.userId ||
          previous.organisationId !== next.organisationId ||
          previous.workspaceId !== next.workspaceId;

        if (!contextChanged) {
          return;
        }

        const prevWorkspaceId = previous?.workspaceId;
        previous = next;

        void queryClient.removeQueries({
          queryKey: ["fetchCampaignWithBookings"],
        });
        void queryClient.removeQueries({
          queryKey: ["fetchCampaignWithBookingsAsAtVersion"],
        });
        if (prevWorkspaceId) {
          void queryClient.removeQueries({
            queryKey: queryKeys.campaigns.fetchWorkspaceCampaigns(
              prevWorkspaceId as idFlavor<"Workspace">
            ),
          });
        }
      },
      reset(): void {
        previous = null;
      },
    };
  };

export const clearAllQueryCaches = (): void => {
  queryClient.clear();
};
